module.exports = __webpack_public_path__ + "img/1-removebg-preview.5df4c92a.png";